import _ from 'lodash'
import RenderData from '../../RenderData'
import Render from './render/render'
import ChildRender from './render/childRender'
import Editor from './editor/editor'
import ChildEditor from './editor/childEditor'
import mainProps, { childProps } from './propsTemplate'
import { RENDER_MODE, MODULE_NAME, CHILD_EDITOR_NAME, CHILD_RENDER_NAME } from './constant'
import i18n from '@/i18n'

const name = MODULE_NAME
const childEditorName = CHILD_EDITOR_NAME
const childRenderName = CHILD_RENDER_NAME

const toolbarItems = [
  {
    tag: name,
    icon: 'icon-image-big',
    get label () {
      return i18n.t('microSite.mediaAndText.bigImgName')
    },
    isShow: true, // todo may need replace with permission,
    staticProps: {
      renderMode: RENDER_MODE.horizontalSingle
    }
  },
  {
    tag: name,
    icon: 'icon-image-left',
    get label () {
      return i18n.t('microSite.mediaAndText.leftImgName')
    },
    isShow: false,
    staticProps: {
      renderMode: RENDER_MODE.verticalSingleLeft
    }
  },
  {
    tag: name,
    icon: 'icon-image-right',
    get label () {
      return i18n.t('microSite.mediaAndText.rightImgName')
    },
    isShow: false,
    staticProps: {
      renderMode: RENDER_MODE.verticalSingleRight
    }
  },
  {
    tag: name,
    icon: 'icon-image-crossed',
    get label () {
      return i18n.t('microSite.mediaAndText.crossedImgName')
    },
    isShow: true,
    staticProps: {
      renderMode: RENDER_MODE.verticalCrossed
    }
  },
  {
    tag: name,
    icon: 'icon-image-top',
    get label () {
      return i18n.t('microSite.mediaAndText.topImgName')
    },
    isShow: true,
    staticProps: {
      renderMode: RENDER_MODE.horizontalMultiple
    }
  }
]

const renders = {
  [name]: Render,
  [childRenderName]: ChildRender
}

const editors = {
  [name]: Editor,
  [childEditorName]: ChildEditor
}

function getEditorTitle (renderData) {
  if (renderData.tag === name) {
    const renderMode = renderData.data.props.renderMode
    switch (renderMode) {
      case RENDER_MODE.horizontalSingle:
        return i18n.t('microSite.mediaAndText.bigImgName')
      case RENDER_MODE.horizontalMultiple:
        return i18n.t('microSite.mediaAndText.topImgName')
      case RENDER_MODE.verticalSingleLeft:
        return i18n.t('microSite.mediaAndText.leftImgName')
      case RENDER_MODE.verticalSingleRight:
        return i18n.t('microSite.mediaAndText.rightImgName')
      case RENDER_MODE.verticalCrossed:
        return i18n.t('microSite.mediaAndText.crossedImgName')
    }
  } else if (renderData.tag === childRenderName) {
    return i18n.t('microSite.mediaAndText.name')
  }
}

function createRenderData (tag, index, parent) {
  if (!renders.hasOwnProperty(tag)) {
    return
  }
  const data = {
    props: _.cloneDeep(mainProps)
  }
  const renderData = new RenderData(tag, data, -1, index, parent, [])
  return renderData
}

function createChildRenderData (parent) {
  const parentTag = parent.tag
  if (parentTag !== name) {
    return
  }
  const index = parent.children.length
  const data = {
    props: _.cloneDeep(childProps)
  }
  const renderData = new RenderData(childEditorName, data, -1, index, parent)
  return renderData
}

const module = {
  name,
  toolbarItems,
  renders,
  editors,
  getEditorTitle,
  createRenderData,
  createChildRenderData
}

const suggestionUploadSize = {
  pc: {
    [RENDER_MODE.verticalCrossed]: '510*340',
    [RENDER_MODE.horizontalMultiple]: '240*160',
    [RENDER_MODE.horizontalSingle]: '1080*540'
  },
  mobile: {

  }
}

export default module

export { suggestionUploadSize }
